import React from "react";
import { Info } from "lucide-react";

/** Honest, consistent AI transparency line wherever generated content is shown. */
export const AiNotice = ({ testId = "ai-transparency-notice", className = "" }) => (
  <p
    data-testid={testId}
    className={`flex items-start gap-2 rounded-xl bg-slate-50 px-3 py-2.5 text-xs leading-relaxed text-slate-600 ${className}`}
  >
    <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" />
    AI-generated content may require review. You remain in control and should review content before approving or
    publishing it.
  </p>
);

export default AiNotice;
